/** Time window presets for dashboard stats and charts. */
export enum DashboardTimeRange {
  H24 = "24h",
  D7 = "7d",
  D30 = "30d",
  D90 = "90d",
}

export const DASHBOARD_TIME_RANGES: readonly DashboardTimeRange[] = [
  DashboardTimeRange.H24,
  DashboardTimeRange.D7,
  DashboardTimeRange.D30,
  DashboardTimeRange.D90,
] as const;

const RANGE_DAYS: Record<DashboardTimeRange, number> = {
  [DashboardTimeRange.H24]: 1,
  [DashboardTimeRange.D7]: 7,
  [DashboardTimeRange.D30]: 30,
  [DashboardTimeRange.D90]: 90,
};

/** ISO start date for the stats API from the end of the selected window. */
export function getDashboardStartDate(range: DashboardTimeRange): string {
  const now = new Date();
  now.setDate(now.getDate() - RANGE_DAYS[range]);
  return now.toISOString();
}

export const DASHBOARD_CHART_PRIMARY = "#7C4DFF";
export const DASHBOARD_CHART_GRADIENT_ID = "dashboardAreaGradient";
